import { debugLogReducer } from "../helpers/debugHelper";
import { types } from "../types/types";

const initialState = {

  administratorStatisticList: {},
  specialistStatisticList: {},
  endUserStatisticList:{},

  endUserStatisticSearchInfoTextModuleList:[],
  endUserStatisticSearchInfoIndicatorsModuleList:[],
  endUserStatisticSearchInfoFiltersModuleList:[],
  endUserStatisticSearchResultRepetitionsModuleList: [],
  endUserStatisticSearchResultLess30ModuleList: [],
  endUserStatisticCompareResultFieldsModuleList: [],
  endUserStatisticCompareResultRepetitionModuleList:[],
  intentionsStats: {
    demandByModule: [],
    topRequested: [],
    topViewed: [],
    searchToTargets: [],
  },
  intentionsLoading: false,
  platformHealth: null,
  flowEngineReports: null,
  userJourney: null,
  searchTrends: null,
  exploreFeed: null,
  endUserActivity: null,
};

export const statisticReducer = (state = initialState, action, getState) => {
  switch (action.type) {
    case types.STATISTICS_ADMINISTRATION_LOADING:
      return {
        ...state,
        administratorStatisticList: action.payload,
      };

      case types.STATISTICS_SPECIALIST_LOADING:
      return {
        ...state,
        specialistStatisticList: action.payload,
      };

      case types.STATISTICS_END_USER_LOADING:
         //console.log("3", action.payload);
      return {
        ...state,
        endUserStatisticList: action.payload,
      };

      //1
      case types.STATISTICS_END_USER_SEARCH_INFO_TEXT_MODULE:
         debugLogReducer(":: STATISTICS_END_USER_SEARCH_INFO_TEXT_MODULE", { endUserStatisticSearchInfoTextModuleList: action.payload})
      return {
        ...state,
        endUserStatisticSearchInfoTextModuleList: action.payload,
      };

      //2
      case types.STATISTICS_END_USER_SEARCH_INFO_INDICATORS_MODULE:
         debugLogReducer(":: STATISTICS_END_USER_SEARCH_INFO_INDICATORS_MODULE", { endUserStatisticSearchInfoIndicatorsModuleList: action.payload})
      return {
        ...state,
        endUserStatisticSearchInfoIndicatorsModuleList: action.payload,
      };

      //3
      case types.STATISTICS_END_USER_SEARCH_INFO_FILTERS_MODULE:
         debugLogReducer(":: STATISTICS_END_USER_SEARCH_INFO_FILTERS_MODULE", { endUserStatisticSearchInfoFiltersModuleList: action.payload})
      return {
        ...state,
        endUserStatisticSearchInfoFiltersModuleList: action.payload,
      };

      //4
      case types.STATISTICS_END_USER_SEARCH_RESULT_REPETITIONS_MODULE:
         debugLogReducer(":: STATISTICS_END_USER_SEARCH_RESULT_REPETITIONS_MODULE", { endUserStatisticSearchResultRepetitionsModuleList: action.payload})
      return {
        ...state,
        endUserStatisticSearchResultRepetitionsModuleList: action.payload,
      };

      //5
      case types.STATISTICS_END_USER_SEARCH_RESULT_LESS30_MODULE:
         debugLogReducer(":: STATISTICS_END_USER_SEARCH_RESULT_LESS30_MODULE", { endUserStatisticSearchResultLess30ModuleList: action.payload})
      return {
        ...state,
        endUserStatisticSearchResultLess30ModuleList: action.payload,
      };

      //6
      case types.STATISTICS_END_USER_COMPARE_RESULT_FIELDS_MODULE:
        debugLogReducer(":: STATISTICS_END_USER_COMPARE_RESULT_FIELDS_MODULE", { endUserStatisticCompareResultFieldsModuleList: action.payload})
      return {
        ...state,
        endUserStatisticCompareResultFieldsModuleList: action.payload,
      };

      //7
      case types.STATISTICS_END_USER_COMPARE_RESULT_REPETITION_MODULE:
         debugLogReducer(":: STATISTICS_END_USER_COMPARE_RESULT_REPETITION_MODULE", { endUserStatisticCompareResultRepetitionModuleList: action.payload})
      return {
        ...state,
        endUserStatisticCompareResultRepetitionModuleList: action.payload,
      };

      case types.STATISTIC_END_USER_CLEAN_STATS:

      return{
        ...state,
        endUserStatisticSearchInfoTextModuleList:[],
        endUserStatisticSearchInfoIndicatorsModuleList:[],
        endUserStatisticSearchInfoFiltersModuleList:[],
        endUserStatisticSearchResultRepetitionsModuleList: [],
        endUserStatisticSearchResultLess30ModuleList: [],
        endUserStatisticCompareResultFieldsModuleList: [],
        endUserStatisticCompareResultRepetitionModuleList:[],
      }

      case types.STATISTICS_INTENTIONS_LOADING:
      return {
        ...state,
        intentionsStats: action.payload || {
          demandByModule: [],
          topRequested: [],
          topViewed: [],
          searchToTargets: [],
        },
        intentionsLoading: false,
      };

      case types.STATISTICS_INTENTIONS_SET_LOADING:
      return {
        ...state,
        intentionsLoading: !!action.payload,
      }

      case types.STATISTICS_HEALTH_LOADING:
      return { ...state, platformHealth: action.payload };

      case types.STATISTICS_FLOW_ENGINE_LOADING:
      return { ...state, flowEngineReports: action.payload };

      case types.STATISTICS_JOURNEY_LOADING:
      return { ...state, userJourney: action.payload };

      case types.STATISTICS_TRENDS_LOADING:
      return { ...state, searchTrends: action.payload };

      case types.STATISTICS_EXPLORE_LOADING:
      return { ...state, exploreFeed: action.payload };

      case types.STATISTICS_END_USER_ACTIVITY_LOADING:
      return { ...state, endUserActivity: action.payload };

    default:
      return state;

    }
}